const TAX_IDENTIFIER_MAX_LENGTH = 20;

export type TaxIdentifierStepValues = {
	taxIdentifier: string;
};

export const EMPTY_TAX_IDENTIFIER: TaxIdentifierStepValues = {
	taxIdentifier: '',
};

export const TAX_IDENTIFIER_SUBTITLE =
	'Персональный идентификационный номер, выданный вам в стране налогового резидентства (ИНН, Tax Identification Number, др).';

/** Буквы, цифры и символы — для иностранного налогового идентификатора */
export const normalizeTaxIdentifier = (value: string): string => {
	return [...value]
		.filter((char) => /\p{L}|\p{N}|\p{P}|\p{S}/u.test(char))
		.join('')
		.slice(0, TAX_IDENTIFIER_MAX_LENGTH);
};

export const formatTaxIdentifierDisplay = (value: string): string => {
	return value;
};

export const isTaxIdentifierStepValid = (values: TaxIdentifierStepValues): boolean => {
	return normalizeTaxIdentifier(values.taxIdentifier).length >= 4;
};

export const buildTaxIdentifierRequest = (values: TaxIdentifierStepValues): {identificationNumber: string} | null => {
	const identificationNumber = normalizeTaxIdentifier(values.taxIdentifier);

	if (identificationNumber.length < 4) {
		return null;
	}

	return {identificationNumber};
};
